import { CSSProperties } from 'react'
import { ButtonBase } from '@mui/material'

interface CardButonProps {
  children: React.ReactNode
  style?: CSSProperties
  sx?: any
  elevation?: boolean
  width?: string
}

export const CardButton = (props: CardButonProps) => {
  const { children, style, elevation, width } = props

  return (
    <ButtonBase
      sx={{
        width: { width },
        marginLeft: { xs: '10px', md: '25px', lg: '20px' },
        marginBottom: { xs: '10px' },
        background: 'white',
        borderRadius: 4,
        // boxShadow: '0.5px 1.5px 1px #ccc',
        border: !elevation ? '1px solid #e0e0e0' : '',
        boxShadow: elevation
          ? '0.5px 1.5px 1px rgba(0,0,0,0.19), 0 3px 3px rgba(0,0,0,0.23)'
          : '',
        ...style
      }}
    >
      {children}
    </ButtonBase>
  )
}
